import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ObjectLookupComponent } from './object-lookup.component';
import { CommodityService } from 'app/server/server.module';

@Component({
  selector: 'app-commodity-object-lookup',
  templateUrl: './commodity-object-lookup.component.html',
  styleUrls: ['./object-lookup.component.scss']
})
export class CommodityObjectLookupComponent extends ObjectLookupComponent {
  constructor(private commodityService: CommodityService) {
    super();
  }

  protected loadObjectByIdFromService(id: number) {
    this.commodityService.get().pipe(take(1), catchError(() => of([]))).subscribe((list: any[]) => {
      this.isLoadingObject = false;
      const result = (list || []).find(c => this.getObjectId(c) === id);
      if (result) {
        this.selectedObject = result;
        this.searchTerm = this.getObjectName(result);
        this.isSearching = false;
      } else {
        this.selectedObject = null;
        this.searchResults = [];
        this.searchTerm = '';
        this.isSearching = true;
      }
    });
  }

  public getObjectType(): string {
    return 'Commodity';
  }

  protected searchObjects(searchText: string): Observable<any[]> {
    if (!searchText) return of([]);
    return this.commodityService.get().pipe(
      map(list => (list || []).filter(c => this.getObjectName(c).toLowerCase().includes(searchText.toLowerCase()))),
      catchError(() => of([]))
    );
  }

  public getObjectName(item: any): string {
    return item?.Name || item?.CommodityName || item?.Description || '';
  }

  public getObjectId(item: any): number | null {
    return item?.CommodityID ?? item?.ID ?? null;
  }
}
